<template>
  <div>
    <b-tabs class="customer_view_tab no-flex-grow mt-2 border-tab">
      <!-- For product View page -->
      <b-tab
        title="Overview"
        active
        :title-link-class="{ 'd-print-none': true, 'd-block d-lg-none': true }"
        class="p-0 d-print-none"
      >
        <div class="py-3">
          <!--  Item Details -->
          <h6
            class="fw-semi-bold theme-text-color px-pad"
            style="padding-bottom: 6px"
          >Product Details</h6>
          <div class="border-bottom"></div>

          <b-row class="px-pad py-2">
            <b-col cols="4">Name</b-col>
            <b-col cols="8" class="text-truncate">
              {{
              list.main_detail.pdt_name
              }}
            </b-col>
          </b-row>
          <b-row class="px-pad py-2">
            <b-col cols="4">Type</b-col>
            <b-col cols="8">{{ list.main_detail.pdt_type }}</b-col>
          </b-row>

          <div class="border-bottom"></div>
          <h6
            class="fw-semi-bold theme-text-color px-pad"
            style="padding-bottom: 6px; padding-top: 10px"
          >Sales Details</h6>
          <div class="border-bottom"></div>

          <b-row class="px-pad py-2">
            <b-col cols="6">Selling Price</b-col>
            <b-col
              cols="6"
              class="text-truncate"
            >{{orgCurrencySymbol}} {{ parseFloat(list.main_detail.pdt_sal_price) }}</b-col>
          </b-row>
          <b-row class="px-pad py-2">
            <b-col cols="6">Sales Account</b-col>
            <b-col cols="6" class="text-truncate">
              {{
              list.main_detail.sales_account
              }}
            </b-col>
          </b-row>
          <b-row
            class="px-pad py-2"
            v-if="
              list.main_detail.sales_desc != '' &&
              list.main_detail.sales_desc != null
            "
          >
            <b-col cols="6">Description</b-col>
            <b-col cols="6" class="text-truncate">
              {{
              list.main_detail.sales_desc
              }}
            </b-col>
          </b-row>

          <div class="border-bottom"></div>
          <template>
            <b-tabs class="customer_view_tab custom-tab" card>
              <b-tab title="Tax Details" active class="px-pad py-2" title-link-class="text-center">
                <!-- <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Tax Preference</div>
                  <div
                    class="cus-view-addr w-50"
                  >{{ list.main_detail.tax_preference==0 ?'Tax Exempt':'Taxable'}}</div>
                </div>
                <div class="d-flex w-100 py-2" v-if="list.main_detail.tax_preference==0">
                  <div class="cus-view-addr w-50 text-muted">Exempt Reason</div>
                  <div class="cus-view-addr w-50">{{ list.main_detail.exempt_reason_name}}</div>
                </div>-->
                <div
                  class="d-flex w-100 py-2"
                  v-if="
                    list.main_detail.tax_details[list.main_detail.pdt_tax_id]
                  "
                >
                  <div class="cus-view-addr w-50 text-muted">Intra State Tax Rate</div>
                  <div class="cus-view-addr w-50">
                    {{
                    list.main_detail.tax_details[list.main_detail.pdt_tax_id]
                    .tax_name
                    }}
                  </div>
                </div>
                <div
                  class="d-flex w-100 py-2"
                  v-if="
                    list.main_detail.tax_details[
                      list.main_detail.pdt_inter_tax_id
                    ]
                  "
                >
                  <div class="cus-view-addr w-50 text-muted">Inter State Tax Rate</div>
                  <div class="cus-view-addr w-50">
                    {{
                    list.main_detail.tax_details[
                    list.main_detail.pdt_inter_tax_id
                    ].tax_name
                    }}
                  </div>
                </div>
              </b-tab>
              <b-tab title="Additional Details" class="px-pad py-2" title-link-class="text-center">
                <template
                  v-if="
                    list.main_detail.pdt_hsn ||
                    list.main_detail.pdt_sku ||
                    list.main_detail.pdt_tags
                  "
                >
                  <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_hsn">
                    <div class="cus-view-addr w-50 text-muted">HSN Code</div>
                    <div class="cus-view-addr w-50">{{ list.main_detail.pdt_hsn }}</div>
                  </div>
                  <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_sku">
                    <div class="cus-view-addr w-50 text-muted">SKU</div>
                    <div class="cus-view-addr w-50">{{ list.main_detail.pdt_sku }}</div>
                  </div>

                  <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_legacy_id">
                    <div class="cus-view-addr w-50 text-muted">Legacy Id</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_legacy_id}}</div>
                  </div>-->
                  <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_tags">
                    <div class="cus-view-addr w-50 text-muted">Product Tags</div>
                    <div class="cus-view-addr w-50">{{ list.main_detail.pdt_tags }}</div>
                  </div>
                  <!-- <div class="d-flex w-100 py-2" v-if="list.main_detail.pdt_desc">
                    <div class="cus-view-addr w-50 text-muted">Product Notes</div>
                    <div class="cus-view-addr w-50">{{list.main_detail.pdt_desc}}</div>
                  </div>-->
                </template>
                <template v-else>
                  <span class="text-muted pt-2 pb-2">No additional details to display</span>
                </template>
              </b-tab>
            </b-tabs>
          </template>

          <template
            v-if="
              reporting_tags.filter(
                (tag) =>
                  list.main_detail[tag.tag_column_name] != '' &&
                  list.main_detail[tag.tag_column_name] != null
              ).length != 0
            "
          >
            <div class="border-bottom"></div>
            <h6
              class="fw-semi-bold theme-text-color px-pad pt-3 cursor_pointer"
              style="padding-bottom: 6px"
            >Reporting Tags</h6>
            <div class="border-bottom"></div>
            <!--  Selling and ales accountant -->

            <div class="w-100 px-pad">
              <div
                class="d-flex w-100 py-2"
                v-for="(tag, index) in reporting_tags"
                :key="index"
                v-if="
                  list.main_detail[tag.tag_column_name] != '' &&
                  list.main_detail[tag.tag_column_name] != null &&
                  list.main_detail[tag.tag_column_name] != 0
                "
              >
                <div class="cus-view-addr w-50 text-muted">{{ tag.tag_name }}</div>

                <div class="cus-view-addr w-50">
                  {{
                  getJsonPresentValue(
                  tag.tag_options,
                  "value",
                  list.main_detail[tag.tag_column_name],
                  "label"
                  )
                  }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </b-tab>

      <b-tab
        title="Bundle Details"
        active
        :title-link-class="{ 'd-print-none': true }"
        class="p-0 d-print-none"
        v-if="list.main_detail.is_inventory == 1"
      >
        <div role="tablist" class="px-pad py-3">
          <div no-body style="display: flow-root">
            <template v-if="page == 'AmcServiceView'">
              <h5 class="mt-3 mb-3">Associated Products</h5>

              <div style="max-width: 900px !important" class="mb-5">
                <table class="table table-bordered reports-table-border">
                  <thead>
                    <th class="text-left">Product details</th>
                    <th>Quantity</th>
                    <th class="text-right">Selling price</th>
                  </thead>
                  <tbody>
                    <tr v-for="item in list.main_detail.associated_item_details" :key="item.id">
                      <td
                        class="text-left text-truncate"
                        style="max-width: 250px; word-break: break-word"
                      >{{ item.item_details_name }}</td>
                      <td class="text-truncate" style="width: 150px">{{ item.associated_itm_qty }}</td>
                      <td
                        class="text-right text-truncate"
                        style="width: 150px; word-break: break-word"
                      >
                        {{orgCurrencySymbol}}
                        {{
                        Number(item.selling_price).toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        })
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
        </div>
      </b-tab>
      <b-tab
        title="Transactions"
        :title-link-class="{ 'd-print-none': true }"
        class="p-0 d-print-none"
        active
      >
        <template
          v-if="!RoutePermission(false, '', '', 'invoice', 'index')&&!RoutePermission(false, '', '', 'paymentsreceived', 'index')&&!RoutePermission(false, '', '', 'quotation', 'index')"
        >
          <p
            class="p-4 px-pad text-muted"
          >You do not have permission to perform view transcations. Please contact your Administrator.</p>
        </template>
        <div role="tablist" class="px-pad py-3" v-else>
          <template v-if="RoutePermission(false, '', '', 'quotation', 'index')">
            <div no-body style="display: flow-root">
              <!--  Invoice and its details -->
              <div
                block
                href="#"
                variant="light"
                style="cursor: pointer"
                aria-controls="quotation_table"
                @click="
                getList('fetchproductquotationview', 1, 10, 'quotationCollapse')
              "
              >
                <span
                  :class="{
                  'fa fa-caret-right': !quotationCollapse,
                  'fa fa-caret-down': quotationCollapse,
                  'pb-1 pr-2': true,
                }"
                ></span>QUOTATION
              </div>

              <b-collapse id="quotation_table" v-model="quotationCollapse" role="tabpanel">
                <b-card-body>
                  <div class="table-responsive">
                    <!--  Invoice Table-->
                    <table class="table table-hover">
                      <!--  Invoice Table head-->
                      <thead style="background: #fbfbfb">
                        <tr>
                          <th>Date</th>
                          <th>Quotation</th>
                          <th>Customer</th>
                          <th class="text-right">QTY</th>
                          <th class="text-right">Unit Price</th>
                          <th class="text-right">Total</th>
                          <th class="text-right">Status</th>
                        </tr>
                      </thead>
                      <!--  Invoice Table body and data -->
                      <tbody>
                        <template
                          v-if="
                          typeof quotation_list.quotation_list == 'undefined' ||
                          quotation_list == '' ||
                          quotation_list.quotation_list.length == 0
                        "
                        >
                          <tr>
                            <td colspan="7" class="text-center">No data to display</td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr v-for="item in quotation_list.quotation_list" :key="item.sal_hdr_id">
                            <td>{{ getDateFormat(item.quot_created_date) }}</td>
                            <td
                              v-if="
                              RoutePermission(
                                false,
                                '',
                                'invoice',
                                'quotation',
                                'index'
                              )
                            "
                            >
                              <router-link
                                class="text-link"
                                :to="{
                                name: 'SalesView',
                                params: { id: item.sal_hdr_id },
                              }"
                              >{{ item.quot_no }}</router-link>
                            </td>
                            <td v-else>{{ item.quot_no }}</td>
                            <td>{{ item.cus_name }}</td>
                            <td class="text-right">
                              {{
                              parseFloat(item.pdt_qty).toLocaleString(
                              undefined,
                              {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              }
                              )
                              }}
                            </td>
                            <td class="text-right">
                              {{
                              orgCurrencySymbol +
                              " " +
                              parseFloat(item.unit_price).toLocaleString(
                              undefined,
                              {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              }
                              )
                              }}
                            </td>
                            <td class="text-right">
                              {{
                              orgCurrencySymbol +
                              " " +
                              parseFloat(item.total).toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              })
                              }}
                            </td>
                            <td class="text-right">{{ item.quot_status_name }}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <nav
                    class="float-right"
                    v-if="
                    typeof quotation_list.quotation_list != 'undefined' &&
                    quotation_list.quotation_list.length > 0
                  "
                  >
                    <ul class="pagination" style="cursor: pointer">
                      <li
                        :style="
                        parseInt(quotation_list.page) == 1
                          ? 'pointer-events:none;opacity : 0.8'
                          : ''
                      "
                        class="page-item"
                        @click="
                        getPaginationList(
                          'fetchcustomerquotationview',
                          parseInt(quotation_list.page) - 1,
                          10
                        )
                      "
                      >
                        <span
                          aria-hidden="true"
                          class="fw-semi-bold fa fa-angle-left mr-2"
                          style="margin-bottom: 4px"
                        ></span>
                      </li>
                      <li class="page-item">
                        {{
                        (quotation_list.page - 1) * quotation_list.show + 1 || 0
                        }}
                        to
                        {{
                        (quotation_list.page - 1) * quotation_list.show +
                        quotation_list.quotation_list.length
                        }}
                      </li>
                      <li
                        :style="
                        parseInt(quotation_list.next_record) == 0
                          ? 'pointer-events:none;opacity : 0.8'
                          : ''
                      "
                        class="page-item"
                        @click="
                        getPaginationList(
                          'fetchproductquotationview',
                          parseInt(quotation_list.page) + 1,
                          10
                        )
                      "
                      >
                        <span
                          aria-hidden="true"
                          class="fw-semi-bold fa fa-angle-right ml-2"
                          style="margin-bottom: 4px"
                        ></span>
                      </li>
                    </ul>
                  </nav>
                  <span
                    class="float-left text-link fw-semi-bold"
                    style="cursor: pointer"
                    @click="getTotalCount('quotation')"
                  >
                    Total Count :
                    {{ total_quotation_list.total_count || "" }}
                  </span>
                </b-card-body>
              </b-collapse>
            </div>
            <hr />
          </template>
          <template v-if="RoutePermission(false, '', '', 'invoice', 'index')">
            <div no-body style="display: flow-root">
              <!--  Invoice and its details -->
              <div
                block
                href="#"
                variant="light"
                style="cursor: pointer"
                aria-controls="invoice_table"
                @click="
                getList('fetchproductinvoiceview', 1, 10, 'invoiceCollapse')
              "
              >
                <span
                  :class="{
                  'fa fa-caret-right': !invoiceCollapse,
                  'fa fa-caret-down': invoiceCollapse,
                  'pb-1 pr-2': true,
                }"
                ></span>INVOICE
              </div>

              <b-collapse id="invoice_table" v-model="invoiceCollapse" role="tabpanel">
                <b-card-body>
                  <div class="table-responsive">
                    <!--  Invoice Table-->
                    <table class="table table-hover">
                      <!--  Invoice Table head-->
                      <thead style="background: #fbfbfb">
                        <tr>
                          <th>Date</th>
                          <th>Invoice</th>
                          <th>Customer</th>
                          <th class="text-right">QTY</th>
                          <th class="text-right">Unit Price</th>
                          <th class="text-right">Total</th>
                          <th class="text-right">Status</th>
                        </tr>
                      </thead>
                      <!--  Invoice Table body and data -->
                      <tbody>
                        <template
                          v-if="
                          typeof invoice_list.invoice_list == 'undefined' ||
                          invoice_list == '' ||
                          invoice_list.invoice_list.length == 0
                        "
                        >
                          <tr>
                            <td colspan="7" class="text-center">No data to display</td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr v-for="(item, index) in invoice_list.invoice_list" :key="index">
                            <td>{{ getDateFormat(item.created_date) }}</td>
                            <td
                              v-if="
                              RoutePermission(
                                false,
                                '',
                                'invoice',
                                'invoice',
                                'index'
                              )
                            "
                            >
                              <router-link
                                class="text-link"
                                :to="{
                                name: 'InvoiceView',
                                params: { id: item.inv_hdr_id },
                              }"
                              >{{ item.inv_no }}</router-link>
                            </td>
                            <td v-else>{{ item.inv_no }}</td>
                            <td>{{ item.cus_name }}</td>
                            <td class="text-right">
                              {{
                              parseFloat(item.pdt_qty).toLocaleString(
                              undefined,
                              {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              }
                              )
                              }}
                            </td>
                            <td class="text-right">
                              {{
                              orgCurrencySymbol +
                              " " +
                              parseFloat(item.unit_price).toLocaleString(
                              undefined,
                              {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              }
                              )
                              }}
                            </td>
                            <td class="text-right">
                              {{
                              orgCurrencySymbol +
                              " " +
                              parseFloat(item.total).toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              })
                              }}
                            </td>
                            <td class="text-right">{{ item.inv_status_name }}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <nav
                    class="float-right"
                    v-if="
                    typeof invoice_list.invoice_list != 'undefined' &&
                    invoice_list.invoice_list.length > 0
                  "
                  >
                    <ul class="pagination" style="cursor: pointer">
                      <li
                        :style="
                        parseInt(invoice_list.page) == 1
                          ? 'pointer-events:none;opacity : 0.8'
                          : ''
                      "
                        class="page-item"
                        @click="
                        getPaginationList(
                          'fetchproductinvoiceview',
                          parseInt(invoice_list.page) - 1,
                          10
                        )
                      "
                      >
                        <span
                          aria-hidden="true"
                          class="fw-semi-bold fa fa-angle-left mr-2"
                          style="margin-bottom: 4px"
                        ></span>
                      </li>
                      <li class="page-item">
                        {{ (invoice_list.page - 1) * invoice_list.show + 1 || 0 }}
                        to
                        {{
                        (invoice_list.page - 1) * invoice_list.show +
                        invoice_list.invoice_list.length
                        }}
                      </li>
                      <li
                        :style="
                        parseInt(invoice_list.next_record) == 0
                          ? 'pointer-events:none;opacity : 0.8'
                          : ''
                      "
                        class="page-item"
                        @click="
                        getPaginationList(
                          'fetchproductinvoiceview',
                          parseInt(invoice_list.page) + 1,
                          10
                        )
                      "
                      >
                        <span
                          aria-hidden="true"
                          class="fw-semi-bold fa fa-angle-right ml-2"
                          style="margin-bottom: 4px"
                        ></span>
                      </li>
                    </ul>
                  </nav>
                  <span
                    class="float-left text-link fw-semi-bold"
                    style="cursor: pointer"
                    @click="getTotalCount('invoice')"
                  >
                    Total Count :
                    {{ total_invoice_list.total_count || "" }}
                  </span>
                </b-card-body>
              </b-collapse>
            </div>
            <hr />
          </template>
          <template v-if="RoutePermission(false, '', '', 'paymentsreceived', 'index')">
            <!-- Credit -->
            <div no-body style="display: flow-root">
              <!--  Invoice and its details -->
              <div
                block
                href="#"
                variant="light"
                style="cursor: pointer"
                aria-controls="credit_table"
                @click="
                getList('fetchproductcreditview', 1, 10, 'creditCollapse')
              "
              >
                <span
                  :class="{
                  'fa fa-caret-right': !creditCollapse,
                  'fa fa-caret-down': creditCollapse,
                  'pb-1 pr-2': true,
                }"
                ></span>CREDIT
              </div>

              <b-collapse id="credit_table" v-model="creditCollapse" role="tabpanel">
                <b-card-body>
                  <div class="table-responsive">
                    <!--  Invoice Table-->
                    <table class="table table-hover">
                      <!--  Invoice Table head-->
                      <thead style="background: #fbfbfb">
                        <tr>
                          <th>Date</th>
                          <th>Credit</th>
                          <th>Customer</th>
                          <th class="text-right">QTY</th>
                          <th class="text-right">Unit Price</th>
                          <th class="text-right">Total</th>
                          <th class="text-right">Status</th>
                        </tr>
                      </thead>
                      <!--  Invoice Table body and data -->
                      <tbody>
                        <template
                          v-if="
                          typeof credit_list.credit_list == 'undefined' ||
                          credit_list == '' ||
                          credit_list.credit_list.length == 0
                        "
                        >
                          <tr>
                            <td colspan="7" class="text-center">No data to display</td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr v-for="(item, index) in credit_list.credit_list" :key="index">
                            <td>{{ getDateFormat(item.crdt_date) }}</td>
                            <td
                              v-if="
                              RoutePermission(
                                false,
                                '',
                                'invoice',
                                'credit',
                                'index'
                              )
                            "
                            >
                              <router-link
                                class="text-link"
                                :to="{
                                name: 'CreditView',
                                params: { id: item.crdt_hdr_id },
                              }"
                              >{{ item.crdt_no }}</router-link>
                            </td>
                            <td v-else>{{ item.crdt_no }}</td>
                            <td>{{ item.cus_name }}</td>
                            <td class="text-right">
                              {{
                              parseFloat(item.pdt_qty).toLocaleString(
                              undefined,
                              {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              }
                              )
                              }}
                            </td>
                            <td class="text-right">
                              {{
                              orgCurrencySymbol +
                              " " +
                              parseFloat(item.unit_price).toLocaleString(
                              undefined,
                              {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              }
                              )
                              }}
                            </td>
                            <td class="text-right">
                              {{
                              orgCurrencySymbol +
                              " " +
                              parseFloat(item.total).toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                              })
                              }}
                            </td>
                            <td class="text-right">{{ item.crdt_status_name }}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <nav
                    class="float-right"
                    v-if="
                    typeof credit_list.credit_list != 'undefined' &&
                    credit_list.credit_list.length > 0
                  "
                  >
                    <ul class="pagination" style="cursor: pointer">
                      <li
                        :style="
                        parseInt(credit_list.page) == 1
                          ? 'pointer-events:none;opacity : 0.8'
                          : ''
                      "
                        class="page-item"
                        @click="
                        getPaginationList(
                          'fetchproductcreditview',
                          parseInt(credit_list.page) - 1,
                          10
                        )
                      "
                      >
                        <span
                          aria-hidden="true"
                          class="fw-semi-bold fa fa-angle-left mr-2"
                          style="margin-bottom: 4px"
                        ></span>
                      </li>
                      <li class="page-item">
                        {{ (credit_list.page - 1) * credit_list.show + 1 || 0 }}
                        to
                        {{
                        (credit_list.page - 1) * credit_list.show +
                        credit_list.credit_list.length
                        }}
                      </li>
                      <li
                        :style="
                        parseInt(credit_list.next_record) == 0
                          ? 'pointer-events:none;opacity : 0.8'
                          : ''
                      "
                        class="page-item"
                        @click="
                        getPaginationList(
                          'fetchproductcreditview',
                          parseInt(credit_list.page) + 1,
                          10
                        )
                      "
                      >
                        <span
                          aria-hidden="true"
                          class="fw-semi-bold fa fa-angle-right ml-2"
                          style="margin-bottom: 4px"
                        ></span>
                      </li>
                    </ul>
                  </nav>
                  <span
                    class="float-left text-link fw-semi-bold"
                    style="cursor: pointer"
                    @click="getTotalCount('credit')"
                  >Total Count : {{ total_credit_list.total_count || "" }}</span>
                </b-card-body>
              </b-collapse>
            </div>
          </template>
        </div>
      </b-tab>
      <b-tab
        title="PriceList view"
        class="p-0 d-print-none"
        v-if="RoutePermission(false, '', '', 'pricelists', 'index')&&
          list.pricing_list_sales.length > 0 
        "
      >
        <b-tabs class="customer_view_tab no-flex-grow mt-4 p-4" pills small>
          <!-- <b-button-group size="sm" class="mb-3">
            <b-button
              :pressed="pricing_list == 'sales_details'"
              :variant="pricing_list == 'sales_details' ? 'primary' : 'light'"
              @click="pricing_list = 'sales_details'"
            >Sales</b-button>
          </b-button-group>-->

          <!-- <h5 class="mt-5 mb-3">Stock Locations</h5> -->
          <div style="max-width: 900px !important" class="mb-5 mt-3">
            <table class="table table-bordered sales-table last-child-border-none total-table">
              <thead>
                <th class="text-left">Name</th>
                <th class="text-right">Pricing Range</th>
                <th class="text-right">Price</th>
                <th class="text-right" style="border: none; background: none !important"></th>
              </thead>
              <tbody
                v-if="
                  (pricing_list == 'sales_details' &&
                    list.pricing_list_sales.length > 0) ||
                  (pricing_list == 'purchase_details' &&
                    list.pricing_list_purchase.length > 0)
                "
              >
                <tr
                  v-for="(item, index) in pricing_list == 'sales_details'
                    ? list.pricing_list_sales
                    : list.pricing_list_purchase"
                  :key="item.id"
                >
                  <td class="text-left" style="max-width: 300px !important">
                    <span class="text">{{ item.pricing_name }}</span>
                  </td>
                  <td class="text-right text-truncate">{{ item.pricing_range }}</td>
                  <td class="text-right" v-if="pricelistedit == true" style="max-width: 100px">
                    <div class="d-flex">
                      <span class="pr-2 pt-2">{{ orgCurrencySymbol }}</span>
                      <input type="text" class="form-control" v-model="item.pricing_rate" />
                    </div>
                  </td>
                  <td
                    class="text-right"
                    v-else
                    style="max-width: 100px"
                  >{{item.pricing_rate?orgCurrencySymbol+' '+ item.pricing_rate:'' }}</td>
                  <td v-if="pricelistedit == false" style="border: none">
                    <i
                      v-if="RoutePermission(false, '', '', 'pricelists', 'update')"
                      class="la la-edit la-lg text-primary cursor_pointer"
                      @click="
                        (pricelistedit = true), (button_id = index);
                        pricingrate_old = item.pricing_rate;
                      "
                    ></i>
                  </td>
                  <td v-else-if="(pricelistedit = true)" style="border: none; max-width: 100px">
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 18px"
                      v-if="submitted === index"
                    ></i>
                    <b-button
                      variant="success"
                      size="sm"
                      @click="SubmitPricing(index)"
                      v-else-if="!submitted && button_id === index"
                      style="
                        height: 23px !important;
                        width: 23px !important;
                        border-radius: 50% !important;
                      "
                    >
                      <i
                        class="la la-check la-lg"
                        style="position: relative; left: -7px; top: -4px"
                      ></i>
                    </b-button>
                    <b-button
                      variant="light"
                      size="sm"
                      v-if="button_id === index"
                      @click="
                        button_id = '';
                        item.pricing_rate = pricingrate_old;
                        pricelistedit = false;
                      "
                      class="ml-2"
                      style="
                        height: 23px !important;
                        width: 23px !important;
                        border-radius: 50% !important;
                      "
                    >
                      <i
                        class="la la-remove la-lg"
                        style="position: relative; left: -8px; top: -4px"
                        @click="
                          item.pricing_rate = pricingrate_old;
                          pricelistedit = false;
                        "
                      ></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    colspan="3"
                    class="text-center"
                    v-if="
                      pricing_list == 'purchase_details' &&
                      list.pricing_list_purchase.length > 0
                    "
                  >
                    The purchase price lists associated with this product will
                    be displayed here
                  </td>
                  <td colspan="3" class="text-center" v-else>
                    The sales price lists associated with this product will be
                    displayed here
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tabs>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import store from "@/store/index";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["list", "page"],
  data() {
    return {
      stock_account: "acc_stock_details",
      invoiceCollapse: false,
      quotationCollapse: false,
      creditCollapse: false,
      salesCollapse: false,
      pricingrate_old: "",
      pricelistedit: false,
      button_id: "",
      submitted: "",
      pricing_list: "sales_details"
    };
  },
  methods: {
    async getTotalCount(type) {
      await store.dispatch("products/viewtotalcount", {
        id: this.$route.params.id,
        type: type
      });
      this[type] = true;
    },
    SubmitPricing(index) {
      var data;
      this.submitted = index;
      data = {
        id:
          this.pricing_list == "sales_details"
            ? this.list.pricing_list_sales[index].pricing_itm_id
            : this.list.pricing_list_purchase[index].pricing_itm_id,
        pricing_rate:
          this.pricing_list == "sales_details"
            ? this.list.pricing_list_sales[index].pricing_rate
            : this.list.pricing_list_purchase[index].pricing_rate
      };
      this.$store.dispatch("products/pricelistedit", data).then(response => {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: response.data.type,
          showCloseButton: true
        });
        this.pricelistedit = false;
        this.submitted = "";
      });
    },
    async getList(url, page, show, type) {
      if (this[type] == false) {
        const Vpage = page || 1;
        const Vshow = show || 10;
        await store.dispatch("products/" + url, {
          page: Vpage,
          show: Vshow,
          id: this.$route.params.id
        });
        this[type] = true;
      } else {
        this[type] = false;
      }
    },
    async getPaginationList(url, page, show) {
      const Vpage = page || 1;
      const Vshow = show || 10;
      await store.dispatch("products/" + url, {
        page: Vpage,
        show: Vshow,
        id: this.$route.params.id
      });
    }
  },
  computed: {
    locationtotal() {
      var good_on_hand = 0,
        commited_stock = 0,
        available_for_sale = 0;
      var item;
      for (item in this.list.main_detail.stocklist) {
        good_on_hand =
          parseInt(
            this.list.main_detail.stocklist[item][this.stock_account][
              "good_on_hand"
            ]
          ) + parseInt(good_on_hand);
        commited_stock =
          parseInt(
            this.list.main_detail.stocklist[item][this.stock_account][
              "commited_stock"
            ]
          ) + parseInt(commited_stock);
        available_for_sale =
          parseInt(
            this.list.main_detail.stocklist[item][this.stock_account][
              "available_for_sale"
            ]
          ) + parseInt(available_for_sale);
      }

      return {
        good_on_hand: good_on_hand,
        commited_stock: commited_stock,
        available_for_sale: available_for_sale
      };
    },
    ...mapState({
      invoice_list: state => state.products.invoice_list,
      quotation_list: state => state.products.quotation_list,
      credit_list: state => state.products.credit_list,
      sales_list: state => state.products.sales_list,
      total_invoice_list: state => state.products.total_invoice_list,
      total_quotation_list: state => state.products.total_quotation_list,
      total_credit_list: state => state.products.total_credit_list,
      total_sales_list: state => state.products.total_sales_list
    }),
    ...mapGetters([
      "orgCurrencySymbol",
      "org_details",
      "pdt_settings_details",
      "reporting_tags"
    ])
  }
};
</script>